import React from 'react';

var SvgThumbsUpMajor = function SvgThumbsUpMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5.867 16.4-1.334-1a2 2 0 0 0-1.2-.4h-1.333a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h2.528a4 4 0 0 0 3.578-2.211l.185-.372a2.563 2.563 0 0 1 2.293-1.417h.709a1.707 1.707 0 0 1 1.707 1.707v3.293h2.74a3 3 0 0 1 2.99 3.25l-.5 6a3 3 0 0 1-2.99 2.75h-4.573a8 8 0 0 1-4.8-1.6Zm5.133-13.4v5h4.74a1 1 0 0 1 .996 1.083l-.5 6a1 1 0 0 1-.996.917h-4.573a6 6 0 0 1-3.6-1.2l-1.334-1a3.997 3.997 0 0 0-.733-.436v-6.384a6 6 0 0 0 4.894-3.298l.186-.372a.564.564 0 0 1 .504-.31h.416Z"
  }));
};

export { SvgThumbsUpMajor as S };
